(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const collages = document.querySelectorAll('.winzer-portrait__collage');

  const paint = () => {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    const vh = window.innerHeight || 1;
    collages.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const start = vh * 0.92;
      const end = -rect.height * 0.35;
      const range = start - end || 1;
      let progress = (start - rect.top) / range;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      el.style.setProperty('--wp-scroll', progress.toFixed(4));

      if (reduced) {
        el.style.setProperty('--wp-hero-y', '0');
        el.style.setProperty('--wp-caption-y', '0');
        return;
      }

      const drift = progress - 0.22;
      el.style.setProperty('--wp-hero-y', (drift * 16).toFixed(2));
      el.style.setProperty('--wp-caption-y', (drift * -8).toFixed(2));
    });
  };

  let frame = 0;
  const requestPaint = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      paint();
    });
  };

  const isQuestion = (el) => {
    if (!el || el.tagName !== 'P') return false;
    const strong = el.firstElementChild;
    return Boolean(
      strong &&
        strong.tagName === 'STRONG' &&
        el.childElementCount === 1 &&
        el.textContent.trim() === strong.textContent.trim()
    );
  };

  const splitInterview = (root) => {
    const talk = root.querySelector('.winzer-portrait__talk');
    if (!talk || talk.dataset.wpSplit === '1') return;

    const interview = talk.querySelector('.winzer-portrait__interview');
    if (!interview) return;

    const field = interview.querySelector('.metafield-rich_text_field') || interview;
    const items = [...field.children].filter((el) => el.nodeType === 1);
    if (!items.length) return;

    const groups = [];
    let bucket = [];
    items.forEach((el) => {
      if (isQuestion(el) && bucket.length) {
        groups.push(bucket);
        bucket = [el];
      } else {
        bucket.push(el);
      }
    });
    if (bucket.length) groups.push(bucket);

    const mid = Math.max(1, Math.ceil(groups.length / 2));
    const colA = document.createElement('div');
    colA.className = 'winzer-portrait__talk-col';
    const colB = document.createElement('div');
    colB.className = 'winzer-portrait__talk-col';

    const plate = talk.querySelector('.winzer-portrait__still--talk');
    if (plate && !window.matchMedia('(max-width: 767px)').matches) colB.appendChild(plate);

    groups.forEach((group, index) => {
      const col = index < mid ? colA : colB;
      group.forEach((el) => col.appendChild(el));
    });

    field.appendChild(colA);
    field.appendChild(colB);
    field.classList.add('is-split');
    talk.dataset.wpSplit = '1';

    field.querySelectorAll('p').forEach((el) => {
      if (!isQuestion(el)) return;
      const text = el.textContent.trim();
      if (/^\d+\s*[.)]/.test(text) || /\?\s*$/.test(text)) {
        el.classList.add('is-question');
      }
    });
  };

  document.querySelectorAll('.winzer-portrait').forEach((root) => splitInterview(root));

  const reelMedia = window.matchMedia('(max-width: 767px)');

  const placeOpeningStill = () => {
    document.querySelectorAll('.winzer-portrait').forEach((root) => {
      if (root.querySelector('.winzer-portrait__quote')) return;
      const collage = root.querySelector(':scope > .winzer-portrait__collage');
      if (!collage) return;
      const tail = root.querySelector(':scope > .winzer-portrait__to-top');

      if (reelMedia.matches) {
        if (tail && collage.nextElementSibling !== tail) root.insertBefore(collage, tail);
        else if (!tail && root.lastElementChild !== collage) root.appendChild(collage);
        return;
      }

      if (root.firstElementChild !== collage) root.insertBefore(collage, root.firstElementChild);
    });
  };

  const placeTalkPlate = () => {
    document.querySelectorAll('.winzer-portrait__chapter--talk').forEach((chapter) => {
      const inner = chapter.querySelector('.winzer-portrait__chapter-inner');
      const plate = chapter.querySelector('.winzer-portrait__still--talk');
      if (!inner || !plate) return;

      if (reelMedia.matches) {
        if (plate.parentElement !== chapter) chapter.insertBefore(plate, inner);
        return;
      }

      const columns = chapter.querySelectorAll('.winzer-portrait__talk-col');
      const colB = columns[columns.length - 1];
      if (colB) {
        if (plate.parentElement !== colB) colB.insertBefore(plate, colB.firstChild);
        return;
      }

      const talk = chapter.querySelector('.winzer-portrait__talk');
      if (talk && plate.parentElement !== talk) talk.insertBefore(plate, talk.firstChild);
    });
  };

  const syncPortraitBar = () => {
    if (!reelMedia.matches) {
      document.body.classList.remove('is-portrait-reel');
      return;
    }

    const vh = window.innerHeight || 1;
    let cover = false;
    document.querySelectorAll('.winzer-portrait').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.35 && rect.bottom > vh * 0.65) cover = true;
    });
    document.body.classList.toggle('is-portrait-reel', cover);
  };

  let barFrame = 0;
  const requestBar = () => {
    if (barFrame) return;
    barFrame = window.requestAnimationFrame(() => {
      barFrame = 0;
      syncPortraitBar();
    });
  };

  document.querySelectorAll('.winzer-portrait__to-top').forEach((button) => {
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  });

  placeOpeningStill();
  placeTalkPlate();
  reelMedia.addEventListener('change', () => {
    placeOpeningStill();
    placeTalkPlate();
    requestBar();
  });
  window.addEventListener('scroll', requestBar, { passive: true });
  window.addEventListener('resize', requestBar);
  requestBar();

  if (!collages.length) return;

  if (reduced) {
    paint();
    return;
  }

  const visible = new Set();
  const syncScroll = () => {
    if (visible.size) {
      window.addEventListener('scroll', requestPaint, { passive: true });
      requestPaint();
    } else {
      window.removeEventListener('scroll', requestPaint);
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-inview', entry.isIntersecting);
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      syncScroll();
    },
    { rootMargin: '30% 0px' }
  );

  collages.forEach((el) => observer.observe(el));
  window.addEventListener('resize', requestPaint);
})();
